import { epicRequest, serverResponse } from 'app'
import System from 'system'

export const INSTITUTION_FETCH = 'INSTITUTION_FETCH'
export const INSTITUTION_FETCH_CANCELED = 'INSTITUTION_FETCH_CANCELED'
export const INSTITUTION_FETCH_ERROR = 'INSTITUTION_FETCH_ERROR'
export const INSTITUTION_FETCH_FULFILLED = 'INSTITUTION_FETCH_FULFILLED'

export const INSTITUTION_LIKE = 'INSTITUTION_LIKE'
export const INSTITUTION_LIKE_CANCELED = 'INSTITUTION_LIKE_CANCELED'
export const INSTITUTION_LIKE_ERROR = 'INSTITUTION_LIKE_ERROR'
export const INSTITUTION_LIKE_FULFILLED = 'INSTITUTION_LIKE_FULFILLED'

export const INSTITUTION_RELATION_FETCH = 'INSTITUTION_RELATION_FETCH'
export const INSTITUTION_RELATION_FETCH_CANCELED = 'INSTITUTION_RELATION_FETCH_CANCELED'
export const INSTITUTION_RELATION_FETCH_ERROR = 'INSTITUTION_RELATION_FETCH_ERROR'
export const INSTITUTION_RELATION_FETCH_FULFILLED = 'INSTITUTION_RELATION_FETCH_FULFILLED'

export const INSTITUTION_DAILY_FETCH = 'INSTITUTION_DAILY_FETCH'
export const INSTITUTION_DAILY_FETCH_CANCELED = 'INSTITUTION_DAILY_FETCH_CANCELED'
export const INSTITUTION_DAILY_FETCH_ERROR = 'INSTITUTION_DAILY_FETCH_ERROR'
export const INSTITUTION_DAILY_FETCH_FULFILLED = 'INSTITUTION_DAILY_FETCH_FULFILLED'

export const INSTITUTION_TOURNAMENTS_FETCH = 'INSTITUTION_TOURNAMENTS_FETCH'
export const INSTITUTION_TOURNAMENTS_FETCH_CANCELED = 'INSTITUTION_TOURNAMENTS_FETCH_CANCELED'
export const INSTITUTION_TOURNAMENTS_FETCH_ERROR = 'INSTITUTION_TOURNAMENTS_FETCH_ERROR'
export const INSTITUTION_TOURNAMENTS_FETCH_FULFILLED = 'INSTITUTION_TOURNAMENTS_FETCH_FULFILLED'

export const INSTITUTION_TOURNAMENT_ACTIVATION_FETCH = 'INSTITUTION_TOURNAMENT_ACTIVATION_FETCH'
export const INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_CANCELED = 'INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_CANCELED'
export const INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_ERROR = 'INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_ERROR'
export const INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_FULFILLED = 'INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_FULFILLED'

export const INSTITUTION_INITIAL_STATE = {
  ...serverResponse(),
  daily: {},
  tournaments: serverResponse(),
}

export const institutionRelationFetch = (institutionId) => ({
  payload: {
    institutionId,
  },
  type: INSTITUTION_RELATION_FETCH,
})

export const institutionRelationFetchFulfilled = (payload) => ({
  payload,
  type: INSTITUTION_RELATION_FETCH_FULFILLED,
})
export const institutionRelationFetchError = (payload) => ({
  payload,
  type: INSTITUTION_RELATION_FETCH_ERROR,
})

export const institutionRelationFetchCanceled = () => ({
  payload: null,
  type: INSTITUTION_RELATION_FETCH_CANCELED,
})

export const institutionRelationFetchEpic = epicRequest({
  actionType: INSTITUTION_RELATION_FETCH,
  errorAction: institutionRelationFetchError,
  filter: () => !!System.AUTH_HEADERS.Authorization,
  fulfilledAction: (response, { payload }) =>
    institutionRelationFetchFulfilled({
      ...response,
      ...payload,
    }),
  request: ({ payload }) => `institution/${payload.institutionId}/relation`,
  untilTypes: INSTITUTION_RELATION_FETCH_CANCELED,
})

export const institutionDailyFetch = (institutionId, day, tz) => ({
  payload: {
    day,
    institutionId,
    tz,
  },
  type: INSTITUTION_DAILY_FETCH,
})

export const institutionDailyFetchFulfilled = (payload) => ({
  payload,
  type: INSTITUTION_DAILY_FETCH_FULFILLED,
})

export const institutionDailyFetchError = (payload) => ({
  payload,
  type: INSTITUTION_DAILY_FETCH_ERROR,
})

export const institutionDailyFetchCanceled = () => ({
  payload: null,
  type: INSTITUTION_DAILY_FETCH_CANCELED,
})

export const institutionDailyFetchEpic = epicRequest({
  actionType: INSTITUTION_DAILY_FETCH,
  errorAction: institutionDailyFetchError,
  fulfilledAction: institutionDailyFetchFulfilled,
  request: ({ payload }) =>
    `institution/${payload.institutionId}/matches?from=${payload.day}&to=${payload.day}&tz=${payload.tz}`,
  untilTypes: INSTITUTION_DAILY_FETCH_CANCELED,
})

export const institutionFetch = (institutionId) => ({
  payload: {
    institutionId,
  },
  type: INSTITUTION_FETCH,
})

export const institutionFetchFulfilled = (payload) => ({
  payload,
  type: INSTITUTION_FETCH_FULFILLED,
})

export const institutionFetchError = (payload) => ({
  payload,
  type: INSTITUTION_FETCH_ERROR,
})

export const institutionFetchCanceled = () => ({
  payload: null,
  type: INSTITUTION_FETCH_CANCELED,
})

export const institutionFetchEpic = epicRequest({
  actionType: INSTITUTION_FETCH,
  errorAction: institutionFetchError,
  fulfilledAction: institutionFetchFulfilled,
  maps: [({ response }, { payload }) => institutionRelationFetch(response.data?.[0]?.id || payload.institutionId)],
  request: ({ payload }) => `institution/${payload.institutionId}`,
  untilTypes: INSTITUTION_FETCH_CANCELED,
})

export const institutionLike = (institutionId, like) => ({
  payload: {
    institutionId,
    like,
  },
  type: INSTITUTION_LIKE,
})

export const institutionLikeFulfilled = (payload) => ({
  payload,
  type: INSTITUTION_LIKE_FULFILLED,
})

export const institutionLikeCanceled = () => ({
  payload: null,
  type: INSTITUTION_LIKE_CANCELED,
})

export const institutionLikeError = (payload) => ({
  payload,
  type: INSTITUTION_LIKE_ERROR,
})

export const institutionLikeEpic = epicRequest({
  actionType: INSTITUTION_LIKE,
  errorAction: institutionLikeError,
  fulfilledAction: institutionLikeFulfilled,
  request: ({ payload }) => ({
    method: payload.like ? 'post' : 'delete',
    url: `institution/${payload.institutionId}/${payload.like ? 'like' : 'unfollow'}`,
  }),
  untilTypes: INSTITUTION_LIKE_CANCELED,
})

export const institutionTournamentsFetch = (institutionId, page) => ({
  payload: {
    institutionId,
    page,
  },
  type: INSTITUTION_TOURNAMENTS_FETCH,
})

export const institutionTournamentsFetchFulfilled = (payload) => ({
  payload,
  type: INSTITUTION_TOURNAMENTS_FETCH_FULFILLED,
})
export const institutionTournamentsFetchError = (payload) => ({
  payload,
  type: INSTITUTION_TOURNAMENTS_FETCH_ERROR,
})

export const institutionTournamentsFetchCanceled = () => ({
  payload: null,
  type: INSTITUTION_TOURNAMENTS_FETCH_CANCELED,
})

export const institutionTournamentsFetchEpic = epicRequest({
  actionType: INSTITUTION_TOURNAMENTS_FETCH,
  errorAction: institutionTournamentsFetchError,
  fulfilledAction: institutionTournamentsFetchFulfilled,
  request: ({ payload }) => `institution/${payload.institutionId}/tournaments/all?page=${payload.page}&per_page=10`,
  untilTypes: INSTITUTION_TOURNAMENTS_FETCH_CANCELED,
})

export const institutionTournamentActivationFetch = (tournamentId, activate) => ({
  payload: {
    activate,
    tournamentId,
  },
  type: INSTITUTION_TOURNAMENT_ACTIVATION_FETCH,
})

export const institutionTournamentActivationFetchFulfilled = (payload) => ({
  payload,
  type: INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_FULFILLED,
})

export const institutionTournamentActivationFetchCanceled = () => ({
  payload: null,
  type: INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_CANCELED,
})

export const institutionTournamentActivationFetchError = (payload) => ({
  payload,
  type: INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_ERROR,
})

export const institutionTournamentActivationFetchEpic = epicRequest({
  actionType: INSTITUTION_TOURNAMENT_ACTIVATION_FETCH,
  errorAction: institutionTournamentActivationFetchError,
  fulfilledAction: institutionTournamentActivationFetchFulfilled,
  request: ({ payload }) => ({
    method: payload.activate ? 'post' : 'delete',
    url: `sports/tournament/${payload.tournamentId}/activate`,
  }),
  untilTypes: INSTITUTION_TOURNAMENT_ACTIVATION_FETCH_CANCELED,
})
